export default __webpack_public_path__ + "static/media/image4.93fc5093.png";